<template>
    <modal :name="modalName" transition="fade" top="0" width="700" height="auto" draggable="true"
        @before-open="beforeOpen" :adaptive="true">
        <div class="modal-container">
            <div class="create-modal-header ">
                <h3>Send a Key</h3>
                <button @click=close>X</button>
            </div>
            <div class="modal-content" @mousedown="() => handleClickToCloseResidentSelector()">
                <div class="modal-intro-information">
                    <label>Visitor First Name*</label>
                    <input ref="firstName" type="text" placeholder="First Name" class="modal-title"
                        v-model="firstName" />
                    <label>Visitor Last Name*</label>
                    <input ref="lastName" type="text" placeholder="Last Name" class="modal-title" v-model="lastName" />
                </div>
                <div class="modal-create-data">
                    <div class="modal-create-data-item">
                        <p class="item-header">Resident Name*</p>
                        <div style="flex:2; z-index: 2; display: flex;" ref="residentData">
                            <option-dropdown-select v-if="showResidentOptions" class="search" style="top: 36px"
                                :options="residentOptions" :searchCallback="(data) => fetchResidents(data)"
                                :onOptionSelected="(option, event) => {
                                    event.stopImmediatePropagation()
                                    residentData = option;
                                    showResidentOptions = false
                                }" />
                            <button v-else-if="residentData != null" class="option-select-dropdown-button"
                                style="flex: 2; display: flex; align-items: center; justify-content: center;">
                                <p style="text-align: center;" @click="showResidentOptions = !showResidentOptions">
                                    {{ residentData.name }} {{ residentData.last_name }}</p>
                            </button>
                            <button v-else class="option-select-dropdown-button"
                                style="flex: 2; display: flex; align-items: center; justify-content: center;">
                                <div style="display: flex; width: 100%; flex-direction: row; justify-content: flex-end;"
                                    @click="showResidentOptions = !showResidentOptions">
                                    <div style="padding-left: 8px; padding-right: 8px; font-weight: bolder;">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                                            <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                            </button>
                        </div>

                    </div>
                    <div class="modal-create-data-item">
                        <p>License Plate Number</p>
                        <input ref="license-plate" type="text" placeholder="Visitor License Plate Number"
                            class="modal-title" v-model="licensePlate" />
                    </div>
                    <div class="modal-create-data-section">
                        <p class="section-header">Key Active Time</p>
                        <div class="modal-create-data-item">
                            <p>Start Time*</p>
                            <input ref="keyStartTime" type="datetime-local" class="visitor-modal-title"
                                v-model="keyStartTime" :min="getMinimumDateForKeys()" />
                        </div>
                        <div class="modal-create-data-item" style="margin-top: 8px;">
                            <p>Expiration Time*</p>
                            <input ref="keyEndTime" type="datetime-local" class="visitor-modal-title"
                                v-model="keyEndTime" :min="getMinimumDateForKeys()" />
                        </div>
                        <div>
                            <input type="checkbox" id="one-time-entry-checkbox" ref="one-time-entry-checkbox"
                                name="one-time-entry-checkbox" v-model="oneTimeEntry" style="margin-top: 8px;">
                            <label style="color: black; margin-left: 18px; font-weight: bolder;"
                                for="one-time-entry-checkbox">One time entry?</label>
                        </div>
                    </div>
                    <div class="modal-create-data-section">
                        <p class="section-header">Send Key By:</p>
                        <div class="modal-checkbox-item" style="margin-bottom: 8px;">
                            <input type="checkbox" ref="sendViaPhoneNumber" v-model="sendViaPhoneNumber" />
                            <div class="modal-create-data-item">
                                <p>Visitor Phone Number +1</p>
                                <input ref="visitorPhoneNumber" type="text" placeholder="Visitor Phone Number"
                                    class="modal-title" v-model="visitorPhoneNumber" />
                            </div>
                        </div>
                        <div class="modal-checkbox-item">
                            <input type="checkbox" ref="sendViaEmail" v-model="sendViaEmail" />
                            <div class="modal-create-data-item">
                                <p>Visitor Email</p>
                                <input ref="visitorEmail" type="text" placeholder="Visitor Email" class="modal-title"
                                    v-model="visitorEmail" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button :disabled="sendButtonDisabled" @click="() => this.handlePress()">Send Key</button>
            </div>
        </div>
    </modal>

</template>
<script>

import * as Constants from "../../js/constants.js";
import CTSRepository from "../../js/CTSRepository.js";
import OptionDropdownSelect from "../layout/OptionDropdownSelect.vue";

const NAME = Constants.CREATE_KEY_MODAL

export default {
    components: {
        OptionDropdownSelect
    },
    props: ["organizationData", "userData"],
    data() {
        return {
            modalName: NAME,
            firstName: "",
            lastName: "",
            businessName: "",
            visitorPhoneNumber: "",
            visitorEmail: "",
            licensePlate: "",
            keyStartTime: this.getMinimumDateForKeys(),
            keyEndTime: this.getTomorrowForKeys(),
            oneTimeEntry: false,
            sendViaPhoneNumber: false,
            sendViaEmail: false,
            residentOptions: [],
            residentData: null,
            sendButtonDisabled: false,
            showResidentOptions: false
        }
    },
    watch: {
        residentData: function (newVal) {
            console.log("Create Key New Resident Data", newVal)
        },
        organizationData: function () {
            this.fetchResidents("")
        }
    },
    mounted() {
        this.fetchResidents("")
    },
    methods: {
        show() {
            this.$modal.show(NAME);
            this.fetchResidents("")
        },
        close() {
            this.firstName = ""
            this.lastName = ""
            this.visitorPhoneNumber = ""
            this.visitorEmail = ""
            this.keyEndTime = this.getTomorrowForKeys()
            this.keyStartTime = this.getMinimumDateForKeys()
            this.licensePlate = ""
            this.oneTimeEntry = false
            this.sendViaEmail = false
            this.sendViaPhoneNumber = false
            this.sendButtonDisabled = false
            this.residentData = null
            this.showResidentOptions = false
            this.$modal.hide(NAME);
        },
        beforeOpen(event) {
            console.log('Before Opening...', event)
            this.showResidentOptions = false
        },
        async fetchResidents(data) {
            if (this.$props.organizationData == null) return
            new CTSRepository({
                organization_id: this.organizationData.organization_id
            }).fetchResidents(data).then(async (responseData) => {
                console.log("Search Data", responseData);
                let mappedData = await responseData.data.map(item => {
                    return {
                        name: `${item.first_name} ${item.last_name} - ${item.subdivision}`,
                        value: item.uid
                    }
                });
                console.log("Mapped Data", mappedData);

                this.residentOptions = mappedData
            }).catch(() => {

            });

        },
        handlePress() {
            this.createAndSendKey()
        },
        handleClickToCloseResidentSelector() {
            if (this.showResidentOptions == true) {
                setTimeout(() => { this.showResidentOptions = false }, 100)
            }
        },
        getKeyType() {
            switch (this.oneTimeEntry) {
                case true:
                    return "Single Use"
                default:
                    return "Multi Use"
            }
        },
        getDeliveryMethods() {
            let methods = []
            this.sendViaEmail && methods.push("email")
            this.sendViaPhoneNumber && methods.push("sms")
            return methods
        },
        /**Validates the Required fields for Key Creation*/
        validateInputs() {
            let missingData = []
            // Visitor First Name
            let firstNameRef = this.$refs['firstName']
            if (this.firstName == "") {
                missingData.push("Missing Visitor First Name")
                firstNameRef.classList.add('invalid')
            }
            // Visitor Last Name
            let lastNameRef = this.$refs['lastName']
            if (this.lastName == "") {
                missingData.push("Missing Visitor Last Name")
                lastNameRef.classList.add('invalid')
            }
            // Associated Resident
            let residentDataRef = this.$refs['residentData']
            if (this.residentData == null) {
                missingData.push("Missing Associated Resident")
                residentDataRef.classList.add('invalid')
            }

            // Key Start Time
            // Key End Time

            // Delivery Methods
            let sendViaPhoneNumberRef = this.$refs['sendViaPhoneNumber']
            let sendViaEmailref = this.$refs['sendViaEmail']
            if (this.sendViaPhoneNumber == false && this.sendViaEmail == false) {
                missingData.push("Select a delivery method for this key")
                sendViaPhoneNumberRef.classList.add('invalidCheckbox')
                sendViaEmailref.classList.add('invalidCheckbox')
            }

            let visitorPhoneNumberRef = this.$refs['visitorPhoneNumber']
            if (this.sendViaPhoneNumber && !this.isPhoneNumberValid()) {
                missingData.push("Please enter a valid phone number")
                visitorPhoneNumberRef.classList.add('invalid')
            }

            let visitorEmailRef = this.$refs['visitorEmail']
            if (this.sendViaEmail && !this.isEmailValid()) {
                missingData.push("Please enter a valid email")
                visitorEmailRef.classList.add('invalid')
            }
            if (missingData.length > 0) {
                alert(missingData.join('\n'))
                return false
            } else {
                return true
            }

        },
        isPhoneNumberValid() {
            const regex = /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
            return regex.test(this.visitorPhoneNumber)
        },
        isEmailValid() {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(this.visitorEmail)
        },
        createAndSendKey() {
            if (!this.validateInputs()) {
                return
            }

            console.log("CreateKeyModal Current Data", JSON.parse(JSON.stringify(this.$data)))
            let body = {
                "resident_uid": this.residentData.value,
                "delivery_methods": this.getDeliveryMethods(),
                "key_type": this.getKeyType(),
                "visitor_last_name": this.lastName,
                "visitor_first_name": this.firstName,
                "visitor_phone_number": `+1${this.visitorPhoneNumber.replace(/\D/g, '')}`,
                "visitor_email": this.visitorEmail,
                "visitor_license_plate": this.licensePlate,
                "business_name": null,
                "date_of_visit": new Date(this.keyStartTime).getTime(),
                "time_active": new Date(this.keyStartTime).getTime(),
                "expiration_time": new Date(this.keyEndTime).getTime(),
                "time_expired": null,
                "visitor_relationship": "Guest",
                "business_type": null,
                "special_instructions": null,
                "visitor_expiration_date": new Date(this.keyEndTime).getTime(),
                "visitor_restrictions": null,
                "incident": null,
                "incident_category": null,
                "current_status": "CREATED",
                "party_id": ""
            }
            console.log("Create Key Body", body)
            this.sendButtonDisabled = true
            new CTSRepository(this.$props.organizationData).createKey(JSON.stringify(body)).then(response => {
                console.log("Create Key Response", response);
                this.close();
            }).catch(err => console.error(err)).finally(() => {
                this.sendButtonDisabled = false
            })
        },
        getMinimumDateForKeys() {
            const date = new Date();
            const offsetDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
            const formatted = offsetDate.toISOString().slice(0, 16);
            return formatted
        },
        getTomorrowForKeys() {
            const date = new Date();
            date.setDate(date.getDate() + 1)
            // Set time to 12:00 AM
            date.setHours(0, 0, 0, 0);
            const offsetDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
            const formatted = offsetDate.toISOString().slice(0, 16);
            return formatted
        }
    }
}
</script>
<style></style>